module.exports = __webpack_public_path__ + "static/babel-config-f94d8182b234ce21ee536dfc85c1c3fa.png";